(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    // Filter accordions, and applying filters: rebuild the URL from the form
  // and reload with `filters=open`, remembering which groups were open so
  // the panel comes back exactly as it was left. Delegated on the document,
  // so it survives the theme editor re-rendering the section.
  (function () {
    if (window.__collectionFiltersBound) return;
    window.__collectionFiltersBound = true;

    var GROUPS_KEY = 'atelier-filter-groups';

    function rememberGroups(form) {
      var open = [];
      form.querySelectorAll('[data-filter-group]').forEach(function (group) {
        var toggle = group.querySelector('.filters__toggle');
        if (toggle && toggle.getAttribute('aria-expanded') === 'true') open.push(group.getAttribute('data-filter-group'));
      });
      try {
        sessionStorage.setItem(GROUPS_KEY, JSON.stringify(open));
      } catch (e) {}
    }

    function reloadOpen(url) {
      var form = document.getElementById('collectionFiltersForm');
      if (form) rememberGroups(form);
      url.searchParams.set('filters', 'open');
      window.location = url.toString();
    }

    function applyFilters() {
      var form = document.getElementById('collectionFiltersForm');
      if (!form) return;
      var url = new URL(window.location);
      var params = new URLSearchParams();
      if (url.searchParams.has('sort_by')) params.set('sort_by', url.searchParams.get('sort_by'));

      new FormData(form).forEach(function (value, key) {
        if (value) params.append(key, value);
      });

      url.search = params.toString();
      reloadOpen(url);
    }

    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('.filters__toggle');
      if (toggle) {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', open);
        return;
      }

      if (e.target.closest('#applyPriceFilter')) {
        applyFilters();
        return;
      }

      // Removing a chip or clearing all keeps the panel open too
      var link = e.target.closest('[data-keep-filters-open]');
      if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        reloadOpen(new URL(link.href, window.location.href));
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches('#collectionFiltersForm input[type="checkbox"]')) return;
      if (input.classList.contains('color-filter-input')) {
        var swatch = input.parentElement.querySelector('.color-swatch');
        if (swatch) swatch.classList.toggle('active', input.checked);
      }
      applyFilters();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('#collectionFiltersForm .price-input')) return;
      e.preventDefault();
      applyFilters();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Hover videos (custom.hover_media): play while the card is hovered or
  // focused, pause and rewind when it is left. preload="none" means the
  // video only loads on the first hover. Skipped under reduced motion.
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function videoFor(target) {
      var card = target && target.closest ? target.closest('.product-card') : null;
      return card ? { card: card, video: card.querySelector('.product-card__hover video') } : null;
    }

    function enter(event) {
      var hit = videoFor(event.target);
      if (!hit || !hit.video || hit.card.contains(event.relatedTarget)) return;
      var playing = hit.video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }

    function leave(event) {
      var hit = videoFor(event.target);
      if (!hit || !hit.video || hit.card.contains(event.relatedTarget)) return;
      hit.video.pause();
      hit.video.currentTime = 0;
    }

    document.addEventListener('mouseover', enter);
    document.addEventListener('mouseout', leave);
    document.addEventListener('focusin', enter);
    document.addEventListener('focusout', leave);
  })();
  } catch(e) { console.error(e); }
})();

})();
